<template>
  <div :id="data.id" class="bg-gray-lighten3 py-20 xl:py-28">
    <div class="container">
      <UiPackery
        v-if="data && data.items && data.items.length > 0"
        :cols="grid.cols"
        :rows="grid.rows"
      >
        <UiPackeryItem
          v-for="(item, i) in data.items"
          :key="i"
          :class="grid.span[item.width]"
          class="group"
        >
          <CatalogCategoryItem
            v-bind="item"
            variation="catalog"
            class="p-6 md:p-4 lg:p-8"
          />
        </UiPackeryItem>
      </UiPackery>
    </div>
  </div>
</template>

<script setup lang="ts">
import CatalogCategoryItem from '~/components/sections/categorySection/CatalogCategoryItem.vue';

const grid = {
  cols: 'grid-cols-1 sm:grid-cols-6',
  rows: 'auto-rows-[296px] sm:auto-rows-[456px]',
  span: {
    1: 'col-span-1 sm:col-span-2',
    1.5: 'col-span-1 sm:col-span-3',
  } as Record<number, string>,
};

interface Props {
  data?: {
    id?: string;
    items: any[];
  };
}

withDefaults(defineProps<Props>(), {
  data: () => ({
    items: [],
  }),
});
</script>
